import FollowUpRulesAPI from 'dashboard/api/followUpRules';

const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

const getters = {
    getFollowUpRules: s => s.records,
    getUIFlags: s => s.uiFlags,
};

const mutations = {
    SET_FOLLOW_UP_RULES(s, rules) {
        s.records = rules;
    },
    ADD_FOLLOW_UP_RULE(s, rule) {
        s.records.push(rule);
    },
    UPDATE_FOLLOW_UP_RULE(s, updatedRule) {
        const idx = s.records.findIndex(r => r.id === updatedRule.id);
        if (idx !== -1) s.records.splice(idx, 1, updatedRule);
    },
    DELETE_FOLLOW_UP_RULE(s, id) {
        s.records = s.records.filter(r => r.id !== id);
    },
    SET_UI_FLAG(s, data) {
        s.uiFlags = { ...s.uiFlags, ...data };
    },
};

const actions = {
    async get({ commit }) {
        commit('SET_UI_FLAG', { isFetching: true });
        try {
            const { data } = await FollowUpRulesAPI.get();
            commit('SET_FOLLOW_UP_RULES', data);
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isFetching: false });
        }
    },

    async create({ commit }, ruleData) {
        commit('SET_UI_FLAG', { isCreating: true });
        try {
            const { data } = await FollowUpRulesAPI.create(ruleData);
            commit('ADD_FOLLOW_UP_RULE', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isCreating: false });
        }
    },

    async update({ commit }, { id, ...ruleData }) {
        commit('SET_UI_FLAG', { isUpdating: true });
        try {
            const { data } = await FollowUpRulesAPI.update(id, ruleData);
            commit('UPDATE_FOLLOW_UP_RULE', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isUpdating: false });
        }
    },

    async delete({ commit }, id) {
        commit('SET_UI_FLAG', { isDeleting: true });
        try {
            await FollowUpRulesAPI.delete(id);
            commit('DELETE_FOLLOW_UP_RULE', id);
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isDeleting: false });
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
